__turbopack_context__.v({
  "bb-icon": "Tooltip-module__R-RMlq__bb-icon",
  "trigger": "Tooltip-module__R-RMlq__trigger",
  "wrapper": "Tooltip-module__R-RMlq__wrapper",
});
